import editNode from './edit-node';

const editText = editNode;

export default editText;